import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { LucideAngularModule, Check, BadgeCheck, ExternalLink } from 'lucide-angular';

import { routes } from './app.routes';

const lucideIcons = LucideAngularModule.pick({ Check, BadgeCheck, ExternalLink });

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(),
    provideRouter(routes),
    importProvidersFrom(lucideIcons),
  ],
};
